import { Expose, Type } from 'class-transformer'

export class RoleType {
  @Expose({ name: 'name' }) label: string

  @Expose({ name: 'id' })
  @Type(() => String)
  value: string
}
